var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14565 19.2214H20.4767C22.5805 19.2214 23.6224 18.1896 23.6224 16.1258V3.88389C23.6224 1.82019 22.5805 0.77832 20.4767 0.77832H3.14565C1.05189 0.77832 0 1.82019 0 3.88389V16.1258C0 18.1896 1.05189 19.2214 3.14565 19.2214ZM3.16569 17.6085C2.16389 17.6085 1.6129 17.0776 1.6129 16.0357V3.97405C1.6129 2.93219 2.16389 2.39122 3.16569 2.39122H20.4567C21.4485 2.39122 22.0095 2.93219 22.0095 3.97405V16.0357C22.0095 17.0776 21.4485 17.6085 20.4567 17.6085H3.16569Z",
    fill: "#EA6C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00746 6.48906H6.21964C6.6404 6.48906 6.99103 6.13843 6.99103 5.71767C6.99103 5.29692 6.63037 4.94629 6.21964 4.94629H5.00746C4.57669 4.94629 4.24609 5.29692 4.24609 5.71767C4.24609 6.13843 4.58671 6.48906 5.00746 6.48906Z",
    fill: "#EA6C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02737 6.34796H18.7448C19.0955 6.34796 19.366 6.06745 19.366 5.71682C19.366 5.3662 19.0955 5.0957 18.7448 5.0957H9.02737C8.67673 5.0957 8.40625 5.3662 8.40625 5.71682C8.40625 6.06745 8.67673 6.34796 9.02737 6.34796Z",
    fill: "#EA6C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00746 9.8245H6.21964C6.63037 9.8245 6.99103 9.48389 6.99103 9.06313C6.99103 8.64238 6.6404 8.30176 6.21964 8.30176H5.00746C4.57669 8.30176 4.24609 8.64238 4.24609 9.06313C4.24609 9.48389 4.57669 9.8245 5.00746 9.8245Z",
    fill: "#EA6C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02737 9.69391H18.7448C19.0955 9.69391 19.366 9.42341 19.366 9.06277C19.366 8.71215 19.0955 8.43164 18.7448 8.43164H9.02737C8.68676 8.43164 8.40625 8.70212 8.40625 9.06277C8.40625 9.4134 8.67673 9.69391 9.02737 9.69391Z",
    fill: "#EA6C52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9931,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.bab66fce59c4f3ba7112a16804f3c843.svg";
export { ForwardRef as ReactComponent };